import authService from './authService';

// Obtener la instancia de axios configurada
const api = authService.getAxiosInstance();

// Servicio para manejar las peticiones a la API
const apiService = {
  // Location Ubigeos
  async getLocationUbigeos() {
    try {
      const response = await api.get('/location-ubigeos/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener ubicaciones:', error);
      throw error;
    }
  },
  
  async getLocationUbigeo(id) {
    try {
      const response = await api.get(`/location-ubigeos/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener ubicación ${id}:`, error);
      throw error;
    }
  },
  
  // Users
  async getUsers() {
    try {
      const response = await api.get('/users/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuarios:', error);
      throw error;
    }
  },
  
  async getUser(id) {
    try {
      const response = await api.get(`/users/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener usuario ${id}:`, error);
      throw error;
    }
  },
  
  async createUser(userData) {
    try {
      const response = await api.post('/users/', userData);
      return response.data;
    } catch (error) {
      console.error('Error al crear usuario:', error);
      throw error;
    }
  },
  
  async updateUser(id, userData) {
    try {
      const response = await api.put(`/users/${id}/`, userData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar usuario ${id}:`, error);
      throw error;
    }
  },
  
  async enableUser(id) {
    try {
      const response = await api.post(`/users/${id}/enable_user/`);
      return response.data;
    } catch (error) {
      console.error(`Error al habilitar usuario ${id}:`, error);
      throw error;
    }
  },
  
  async disableUser(id) {
    try {
      const response = await api.post(`/users/${id}/disable_user/`);
      return response.data;
    } catch (error) {
      console.error(`Error al deshabilitar usuario ${id}:`, error);
      throw error;
    }
  },
  
  // Branches
  async getBranches() {
    try {
      const response = await api.get('/branches/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener sucursales:', error);
      throw error;
    }
  },
  
  async getBranch(id) {
    try {
      const response = await api.get(`/branches/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener sucursal ${id}:`, error);
      throw error;
    }
  },
  
  async createBranch(branchData) {
    try {
      const response = await api.post('/branches/', branchData);
      return response.data;
    } catch (error) {
      console.error('Error al crear sucursal:', error);
      throw error;
    }
  },
  
  async updateBranch(id, branchData) {
    try {
      const response = await api.put(`/branches/${id}/`, branchData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar sucursal ${id}:`, error);
      throw error;
    }
  },
  
  async enableBranch(id) {
    try {
      const response = await api.post(`/branches/${id}/enable_branch/`);
      return response.data;
    } catch (error) {
      console.error(`Error al habilitar sucursal ${id}:`, error);
      throw error;
    }
  },
  
  async disableBranch(id) {
    try {
      const response = await api.post(`/branches/${id}/disable_branch/`);
      return response.data;
    } catch (error) {
      console.error(`Error al deshabilitar sucursal ${id}:`, error);
      throw error;
    }
  },
  
  // Branch Balances
  async getBranchBalances(branchId) {
    try {
      const response = await api.get('/branch-balances/', {
        params: { branch_id: branchId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener balances de la sucursal ${branchId}:`, error);
      throw error;
    }
  },
  
  async createBranchBalance(balanceData) {
    try {
      const response = await api.post('/branch-balances/', balanceData);
      return response.data;
    } catch (error) {
      console.error('Error al crear balance de sucursal:', error);
      throw error;
    }
  },
  
  async updateBranchBalance(id, balanceData) {
    try {
      const response = await api.put(`/branch-balances/${id}/`, balanceData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar balance de sucursal ${id}:`, error);
      throw error;
    }
  },
  
  // Transfers
  async getTransfers() {
    try {
      const response = await api.get('/transfers/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener transferencias:', error);
      throw error;
    }
  },
  
  async getTransfer(id) {
    try {
      const response = await api.get(`/transfers/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener transferencia ${id}:`, error);
      throw error;
    }
  },
  
  async createTransfer(transferData) {
    try {
      const response = await api.post('/transfers/', transferData);
      return response.data;
    } catch (error) {
      console.error('Error al crear transferencia:', error);
      throw error;
    }
  },
  
  async changeTransferStatus(id, status, comments) {
    try {
      const response = await api.patch(`/transfers/${id}/change-status/`, {
        status,
        comments,
      });
      return response.data;
    } catch (error) {
      console.error(`Error al cambiar estado de transferencia ${id}:`, error);
      throw error;
    }
  },
  
  // Clients
  async getClients() {
    try {
      const response = await api.get('/clients/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener clientes:', error);
      throw error;
    }
  },
  
  async getClient(id) {
    try {
      const response = await api.get(`/clients/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener cliente ${id}:`, error);
      throw error;
    }
  },
  
  async createClient(clientData) {
    try {
      const response = await api.post('/clients/', clientData);
      return response.data;
    } catch (error) {
      console.error('Error al crear cliente:', error);
      throw error;
    }
  },
  
  async updateClient(id, clientData) {
    try {
      const response = await api.put(`/clients/${id}/`, clientData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar cliente ${id}:`, error);
      throw error;
    }
  },
  
  // Roles
  async getRoles() {
    try {
      const response = await api.get('/roles/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener roles:', error);
      throw error;
    }
  },
  
  async getRole(id) {
    try {
      const response = await api.get(`/roles/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener rol ${id}:`, error);
      throw error;
    }
  },
  
  // User Roles
  async getUserRoles(userId) {
    try {
      const response = await api.get('/user-roles/', {
        params: { user_id: userId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener roles del usuario ${userId}:`, error);
      throw error;
    }
  },
  
  async updateUserRoles(userId, roleIds) {
    try {
      const response = await api.post('/user-roles/update-user-roles/', {
        user_id: userId,
        role_ids: roleIds
      });
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar roles del usuario ${userId}:`, error);
      throw error;
    }
  },
  
  // User Branches
  async getUserBranches(userId) {
    try {
      const response = await api.get('/user-branches/', {
        params: { user_id: userId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener sucursales del usuario ${userId}:`, error);
      throw error;
    }
  },
  
  async updateUserBranches(userId, branchIds) {
    try {
      const response = await api.post('/user-branches/update-user-branches/', {
        user_id: userId,
        branch_ids: branchIds
      });
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar sucursales del usuario ${userId}:`, error);
      throw error;
    }
  },
  
  // Transfer States
  async getTransferStates(transferId) {
    try {
      const response = await api.get('/transfer-states/by_transfer/', {
        params: { transfer_id: transferId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener estados de la transferencia ${transferId}:`, error);
      throw error;
    }
  },
  
  // Transfer Commissions
  async getTransferCommission(transferId) {
    try {
      const response = await api.get('/transfer-commissions/', {
        params: { transfer_id: transferId }
      });
      // Devolver el primer elemento si hay resultados
      return response.data.length > 0 ? response.data[0] : null;
    } catch (error) {
      console.error(`Error al obtener comisión de la transferencia ${transferId}:`, error);
      throw error;
    }
  },
  
  async getTransferCommissions(transferId) {
    try {
      const response = await api.get('/transfer-commissions/', {
        params: { transfer_id: transferId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener comisiones de la transferencia ${transferId}:`, error);
      throw error;
    }
  },
  
  async createCustomCommission(transferId, commissionValue) {
    try {
      const response = await api.post('/transfer-commissions/custom_commission/', {
        transfer_id: transferId,
        commission_value: commissionValue
      });
      return response.data;
    } catch (error) {
      console.error('Error al crear comisión personalizada:', error);
      throw error;
    }
  },
  
  async deleteTransferCommission(commissionId) {
    try {
      await api.delete(`/transfer-commissions/${commissionId}/`);
      return true;
    } catch (error) {
      console.error(`Error al eliminar comisión ${commissionId}:`, error);
      throw error;
    }
  },
  
  // Calculate Commission
  async calculateCommission(amount, currencyType) {
    try {
      const response = await api.post('/commissions/calculate/', {
        amount,
        currency_type: currencyType
      });
      return response.data;
    } catch (error) {
      console.error('Error al calcular comisión:', error);
      throw error;
    }
  },
  
  // Money Shipments
  async getMoneyShipments() {
    try {
      const response = await api.get('/money-shipments/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener envíos de dinero:', error);
      throw error;
    }
  },
  
  async getMoneyShipment(id) {
    try {
      const response = await api.get(`/money-shipments/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener envío de dinero ${id}:`, error);
      throw error;
    }
  },
  
  async createMoneyShipment(shipmentData) {
    try {
      const response = await api.post('/money-shipments/', shipmentData);
      return response.data;
    } catch (error) {
      console.error('Error al crear envío de dinero:', error);
      throw error;
    }
  },
  
  async changeMoneyShipmentStatus(id, status, comments) {
    try {
      const response = await api.post(`/money-shipments/${id}/change_status/`, {
        status,
        comments,
      });
      return response.data;
    } catch (error) {
      console.error(`Error al cambiar estado de envío de dinero ${id}:`, error);
      throw error;
    }
  },
  
  // Money Shipment States
  async getMoneyShipmentStates(shipmentId) {
    try {
      const response = await api.get('/money-shipment-states/by_shipment/', {
        params: { shipment_id: shipmentId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener estados del envío de dinero ${shipmentId}:`, error);
      throw error;
    }
  },
  
  // Balance Movements
  async getBalanceMovements() {
    try {
      const response = await api.get('/balance-movements/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener movimientos de balance:', error);
      throw error;
    }
  },
  
  async getBalanceMovementsByBranch(branchId) {
    try {
      const response = await api.get('/balance-movements/by_branch/', {
        params: { branch_id: branchId }
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener movimientos de balance de la sucursal ${branchId}:`, error);
      throw error;
    }
  },
};

export default apiService;